'use strict';

var toPull = require('stream-to-pull-stream');

var lsReadableStream = require('./ls-readable-stream');

module.exports = function (send) {
  return function (args, opts) {
    opts = opts || {};
    return toPull.source(lsReadableStream(send)(args, opts));
  };
};